import type { Marketplace } from '@amzn/journeys-common';

export const DEFAULT_LAUNCH_DATE_WINDOW_HOURS = 48;
/**
 * As part of this SIM: https://t.corp.amazon.com/P136165185,
 * the NA launch gating window is being changed to (T-7), i.e, 7*24 = 168 Hours
 */
const T7_LAUNCH_DATE_WINDOW_HOURS = 168;

/**
 * As part of this SIM: https://issues.amazon.com/Journeys-12412,
 * we want to enable publishing earlier than the default 48 hours for Intl MPs
 */
const INTL_LAUNCH_GATING_HOURS = 98;

export const MARKETPLACE_LAUNCH_DATE_WINDOW_HOURS: Partial<Record<Marketplace, number>> = {
  // International marketplaces - (T-98) hour restriction (SIM Journeys-12412)
  AU: INTL_LAUNCH_GATING_HOURS,
  BE: INTL_LAUNCH_GATING_HOURS,
  CA: T7_LAUNCH_DATE_WINDOW_HOURS, // NA
  DE: INTL_LAUNCH_GATING_HOURS,
  ES: INTL_LAUNCH_GATING_HOURS,
  FR: INTL_LAUNCH_GATING_HOURS,
  GB: INTL_LAUNCH_GATING_HOURS,
  IE: INTL_LAUNCH_GATING_HOURS,
  IT: INTL_LAUNCH_GATING_HOURS,
  JP: INTL_LAUNCH_GATING_HOURS,
  MX: T7_LAUNCH_DATE_WINDOW_HOURS, // NA
  NL: INTL_LAUNCH_GATING_HOURS,
  US: T7_LAUNCH_DATE_WINDOW_HOURS, // NA
};
